import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-forbidden403',
  standalone: true,
  imports: [ButtonModule, TranslateModule],
  templateUrl: './forbidden403.component.html',
  styleUrl: './forbidden403.component.scss'
})
export class Forbidden403Component {
  goback() {
    window.history.back();
  }
}
